import { createSvgIcon } from '@mui/material';

export const SideLoading = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10 17H22V15V6.00004V4L20 4.00004H4C3.46957 4.00004 2.96086 4.21075 2.58579 4.58582C2.21071 4.9609 2 5.4696 2 6.00004V17H4C4 17.7957 4.31607 18.5587 4.87868 19.1214C5.44129 19.684 6.20435 20 7 20C7.79565 20 8.55871 19.684 9.12132 19.1214C9.68393 18.5587 10 17.7957 10 17ZM6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16C7.26522 16 7.51957 16.1054 7.70711 16.2929C7.89464 16.4805 8 16.7348 8 17C8 17.2653 7.89464 17.5196 7.70711 17.7071C7.51957 17.8947 7.26522 18 7 18C6.73478 18 6.48043 17.8947 6.29289 17.7071C6.10536 17.5196 6 17.2653 6 17C6 16.7348 6.10536 16.4805 6.29289 16.2929ZM20.5 5.5H13.5V15.5H20.5V5.5ZM11 5.5H12V15.5H11V5.5ZM10 5.5H9V15.5H10V5.5Z"
    fill="currentColor"
  />,
  'CnxSideLoading',
);
